<template>
  <div class="footer">
    Design by 赵无妨个人博客
  </div>
</template>

<script>
  export default{
    name: 'Footer'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue